<div class="row">
  <div class="py-2 col-5 col-sm-3 col-lg-2">Kit Barcode #:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.kitBarcode }}</div>
  @if (showVACORISNumber) {
    <div class="py-2 col-5 col-sm-3 col-lg-2">VACORIS #:</div>
    <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.docNumber }}</div>
  }
</div>
<div class="row">
  <div class="py-2 col-5 col-sm-3 col-lg-2">Date Entered:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.dateEntered | date: 'M/d/yyyy' }}</div>
  <div class="py-2 col-5 col-sm-3 col-lg-2">Agency Name:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.agencyName }}</div>
</div>
<div class="row">
  <div class="py-2 col-5 col-sm-3 col-lg-2">Last Name:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.lastName }}</div>
  <div class="py-2 col-5 col-sm-3 col-lg-2">First Name:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.firstName }}</div>
  <div class="py-2 col-5 col-sm-3 col-lg-2">Middle Initial:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.middleInitial }}</div>
</div>
<div class="row">
  <div class="py-2 col-5 col-sm-3 col-lg-2">Suffix:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.nameSuffix }}</div>
  <div class="py-2 col-5 col-sm-3 col-lg-2">Aliases:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ renderAliases(dnaSample.aliases) }}</div>
</div>
<div class="row">
  <div class="py-2 col-5 col-sm-3 col-lg-2">Gender:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.gender }}</div>
  <div class="py-2 col-5 col-sm-3 col-lg-2">Race:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.race }}</div>
</div>
<div class="row">
  <div class="py-2 col-5 col-sm-3 col-lg-2">Date of Birth:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.dateOfBirth | date: 'M/d/yyyy' }}</div>
  <div class="py-2 col-5 col-sm-3 col-lg-2">SSNs:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label" [innerHtml]="renderSSNs(dnaSample.ssns)"></div>
  <div class="py-2 col-5 col-sm-3 col-lg-2">SID#:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.sid }}</div>
</div>
<div class="row">
  <div class="py-2 col-5 col-sm-3 col-lg-2">Date Collected:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.dateCollected | date: 'M/d/yyyy' }}</div>
  <div class="py-2 col-5 col-sm-3 col-lg-2">Sample Collected By:</div>
  <div class="py-2 col-7 col-sm-3 col-lg-2 bold-label">{{ dnaSample.collectedBy }}</div>
</div>
